module.exports = __webpack_public_path__ + "img/icon-members-orange.079b3926.svg";